export * from './light-mobile/divider';
export var THEMES;
(function (THEMES) {
    THEMES["LIGHT_MOBILE"] = "light-mobile";
    THEMES["DARK_MOBILE"] = "dark-mobile";
})(THEMES || (THEMES = {}));
